import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import axiosRetry, { exponentialDelay } from "axios-retry";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs/plugin/utc";

import { RootState, store } from "../store/store";

dayjs.extend(dayjsPluginUTC);

function getRootState(): RootState {
  return store.getState();
}

export const app_uri: string = window.__config.API_URL;

const axiosClient = (): AxiosInstance => {
  const axiosClient = axios.create();
  axiosRetry(axiosClient, { retries: 2, retryDelay: exponentialDelay });

  function doConfig(config: AxiosRequestConfig): AxiosRequestConfig {
    const token = getRootState().auth.user?.access_token;

    config.headers = {
      ...(config.headers as any),
      "Content-Type": config.data instanceof FormData ? "multipart/form-data" : "application/json",
      "Access-Control-Allow-Origin": process.env.NODE_ENV === "development" ? "*" : "*.campaustralia.com.au",
      Authorization: "Bearer " + token,
    };
    return config;
  }

  axiosClient.interceptors.request.use((config: any) => doConfig(config));

  axiosClient.interceptors.response.use(
    (response: any) => response,
    (error: any) => Promise.reject(error)
  );

  return axiosClient;
};

export default axiosClient;
